import React from "react";
import styled from "styled-components";
const MainCont = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
`;

const NewEvent = () => {
  return (
    <MainCont>
      <h1>NewEvent</h1>
    </MainCont>
  );
};

export default NewEvent;
